(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-affiliate"]) return;
  try {
    
  (() => {
    const signupSource = document.querySelector('.collabs-page__cta-main');
    if (signupSource) {
      const signupUrl = signupSource.href;
      document.querySelectorAll('.js-signup-link').forEach((link) => {
        link.setAttribute('href', signupUrl);
      });
    }

    document.querySelectorAll('.faq-item').forEach((faq) => {
      const button = faq.querySelector('.faq-item__title');
      if (!button) {
        return;
      }

      button.addEventListener('click', (event) => {
        event.preventDefault();
        faq.classList.toggle('active');
      });
    });

    const heroVideoWrap = document.querySelector('.hero-affiliate__video');
    const heroUnmuteButton = heroVideoWrap?.querySelector('.hero-affiliate__video-unmute');
    const heroVideo = heroVideoWrap?.querySelector('video');

    if (heroVideoWrap && heroUnmuteButton && heroVideo) {
      heroUnmuteButton.addEventListener('click', (event) => {
        event.preventDefault();
        heroVideo.muted = !heroVideo.muted;
        heroVideoWrap.classList.toggle('playing');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-ambassador"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-ambassador-upload]';
    const allowedExtensions = ['mp4', 'mov'];
    const allowedMimeTypes = ['video/mp4', 'video/quicktime'];
    const maxFileSize = 40 * 1024 * 1024;

    const getFileKey = (file) => `${file.name}-${file.size}-${file.lastModified}`;

    const getFileExtension = (fileName) => {
      const parts = fileName.split('.');

      if (parts.length < 2) {
        return '';
      }

      return parts.pop().toLowerCase();
    };

    const formatFileSize = (bytes) => {
      const megabytes = bytes / (1024 * 1024);
      const decimals = megabytes >= 10 ? 1 : 2;

      return `${megabytes.toFixed(decimals).replace(/\.0+$/, '').replace(/(\.\d*[1-9])0+$/, '$1')} MB`;
    };

    const parseResponse = async (response) => {
      const text = await response.text();

      if (!text) {
        return null;
      }

      try {
        return JSON.parse(text);
      } catch (error) {
        return null;
      }
    };

    const isSuccessfulResponse = (response, payload) => {
      if (!response.ok) {
        return false;
      }

      if (payload && typeof payload.success === 'boolean') {
        return payload.success;
      }

      return true;
    };

    const getResponseMessage = (payload) => {
      if (!payload) {
        return '';
      }

      if (typeof payload.message === 'string' && payload.message.length > 0) {
        return payload.message;
      }

      if (payload.errors && typeof payload.errors === 'object') {
        const firstErrorGroup = Object.values(payload.errors).find((value) => Array.isArray(value) && value.length > 0);

        if (firstErrorGroup) {
          return firstErrorGroup[0];
        }
      }

      return '';
    };

    const isAllowedFileType = (file) => {
      const extension = getFileExtension(file.name);

      if (allowedExtensions.includes(extension)) {
        return true;
      }

      return allowedMimeTypes.includes(file.type);
    };

    const setError = (errorNode, messages) => {
      const text = messages.join(' ');

      errorNode.textContent = text;
      errorNode.hidden = text.length === 0;
    };

    const setVisibility = (node, isVisible) => {
      if (!node) {
        return;
      }

      node.hidden = !isVisible;
    };

    const updateFileButtonText = (label, filesCount) => {
      if (!label) {
        return;
      }

      const defaultText = label.dataset.defaultText || '';
      const moreText = label.dataset.moreText || defaultText;

      label.textContent = filesCount > 0 ? moreText : defaultText;
    };

    const scrollToTopOfSection = (sectionRoot) => {
      smoothScroll(sectionRoot, 1000);
    };

    const syncInputFiles = (input, files) => {
      const dataTransfer = new DataTransfer();

      files.forEach((file) => {
        dataTransfer.items.add(file);
      });

      input.files = dataTransfer.files;
    };

    const renderFileList = (list, template, files, onRemove) => {
      list.innerHTML = '';
      list.hidden = files.length === 0;

      files.forEach((file, index) => {
        const fragment = template.content.cloneNode(true);
        const row = fragment.querySelector('.form__file-info');
        const fileName = row.querySelector('.form__file-name');
        const fileSize = row.querySelector('.form__file-size');
        const removeButton = row.querySelector('.form__file-delete');
        const removeLabel = list.dataset.removeLabel || '';

        fileName.textContent = file.name;
        fileSize.textContent = formatFileSize(file.size);

        if (removeLabel) {
          removeButton.setAttribute('aria-label', `${removeLabel} ${file.name}`);
        }

        removeButton.addEventListener('click', () => {
          onRemove(index);
        });

        list.appendChild(fragment);
      });
    };

    const initUpload = (root) => {
      if (!root || root.dataset.ambassadorUploadReady === 'true') {
        return;
      }

      const input = root.querySelector('[data-ambassador-file-input]');
      const list = root.querySelector('[data-ambassador-file-list]');
      const template = root.querySelector('[data-ambassador-file-template]');
      const errorNode = root.querySelector('[data-ambassador-file-error]');
      const fileLabel = root.querySelector('[data-ambassador-file-label]');
      const form = root.querySelector('[data-ambassador-form]');
      const submitError = root.querySelector('[data-ambassador-submit-error]');
      const submitSuccess = root.querySelector('[data-ambassador-submit-success]');
      const submitButton = form?.querySelector('button[type="submit"]');
      const uploadUrl = root.dataset.uploadUrl || '';
      const submitUrl = root.dataset.submitUrl || '';

      if (!input || !list || !template || !errorNode || !form || !submitButton || !uploadUrl || !submitUrl) {
        return;
      }

      root.dataset.ambassadorUploadReady = 'true';

      let files = Array.from(input.files || []);

      const updateList = () => {
        syncInputFiles(input, files);
        updateFileButtonText(fileLabel, files.length);
        renderFileList(list, template, files, (indexToRemove) => {
          files = files.filter((_, index) => index !== indexToRemove);
          setVisibility(submitError, false);
          updateList();
        });
      };

      const uploadFile = async (file) => {
        const uploadData = new FormData();
        uploadData.append('file', file, file.name);

        const response = await fetch(uploadUrl, {
          method: 'POST',
          body: uploadData,
          headers: {
            Accept: 'application/json'
          }
        });
        const payload = await parseResponse(response);

        if (!isSuccessfulResponse(response, payload)) {
          throw new Error(getResponseMessage(payload) || 'Upload failed');
        }

        const fileUrl = payload.data.url;

        if (!fileUrl) {
          throw new Error('Missing uploaded file URL');
        }

        return fileUrl;
      };

      const submitApplication = async (fileLinks) => {
        const submissionData = new FormData(form);
        submissionData.set('page_url', window.location.href);
        submissionData.set('source', 'page-ambassador');

        fileLinks.forEach((link) => {
          submissionData.append('files[]', link);
        });

        const response = await fetch(submitUrl, {
          method: 'POST',
          body: submissionData,
          headers: {
            Accept: 'application/json'
          }
        });
        const payload = await parseResponse(response);

        if (!isSuccessfulResponse(response, payload)) {
          throw new Error(getResponseMessage(payload) || 'Application submit failed');
        }

        return payload;
      };

      input.addEventListener('change', () => {
        const nextFiles = Array.from(input.files || []);
        const fileMap = new Map(files.map((file) => [getFileKey(file), file]));
        const invalidTypeMessage = errorNode.dataset.invalidTypeMessage || '';
        const invalidSizeMessage = errorNode.dataset.invalidSizeMessage || '';
        const errors = [];

        nextFiles.forEach((file) => {
          if (!isAllowedFileType(file)) {
            if (invalidTypeMessage) {
              errors.push(`${invalidTypeMessage} ${file.name}`);
            }

            return;
          }

          if (file.size > maxFileSize) {
            if (invalidSizeMessage) {
              errors.push(`${invalidSizeMessage} ${file.name}`);
            }

            return;
          }

          fileMap.set(getFileKey(file), file);
        });

        files = Array.from(fileMap.values());
        setError(errorNode, errors);
        setVisibility(submitError, false);
        input.value = '';
        updateList();
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        setVisibility(submitError, false);
        setVisibility(submitSuccess, false);
        const requiredMessage = errorNode.dataset.requiredMessage || '';

        if (files.length === 0) {
          setError(errorNode, requiredMessage ? [requiredMessage] : []);
          return;
        }

        setError(errorNode, []);

        submitButton.disabled = true;
        submitButton.classList.add('is-loading');

        try {
          const uploadedLinks = [];

          for (const file of files) {
            const link = await uploadFile(file);
            uploadedLinks.push(link);
          }

          await submitApplication(uploadedLinks);

          form.reset();
          files = [];
          setError(errorNode, []);
          updateList();
          form.hidden = true;
          setVisibility(submitSuccess, true);
          requestAnimationFrame(() => {
            scrollToTopOfSection(root);
          });
        } catch (error) {
          console.error('Ambassador application submit failed.', error);
          setVisibility(submitError, true);
        } finally {
          submitButton.disabled = false;
          submitButton.classList.remove('is-loading');
        }
      });

      updateList();
    };

    const initAllUploads = (scope = document) => {
      const roots = scope.matches?.(rootSelector)
        ? [scope]
        : Array.from(scope.querySelectorAll(rootSelector));

      roots.forEach(initUpload);
    };

    initAllUploads();

    document.addEventListener('shopify:section:load', (event) => {
      initAllUploads(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-collaborations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const modal = document.querySelector('.modal--collab');
    if (!modal) {
      return;
    }

    const subjectSelect = modal.querySelector('[data-collab-subject-select]');
    if (!subjectSelect) {
      return;
    }

    document.querySelectorAll('[data-collab-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const subject = button.dataset.collabSubject;
        if (!subject) {
          return;
        }

        const matchingOption = Array.from(subjectSelect.options).find((option) => option.value === subject);
        if (matchingOption) {
          subjectSelect.value = subject;
          return;
        }

        const firstOption = subjectSelect.options[0];
        if (!firstOption) {
          return;
        }

        firstOption.value = subject;
        firstOption.text = subject;
        subjectSelect.value = subject;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {

    function initContactForm() {

      const supportForm = document.querySelector('.js-support-form-container');
      const contactLinksGroups = document.querySelector('.js-contact-links-groups');

      if (!supportForm) return;

      const queryParams = new URLSearchParams(window.location.search);

      if (queryParams.get('support') === 'true') {
        supportForm.hidden = false;
        if (contactLinksGroups) contactLinksGroups.hidden = true;
      }
    }


    function initReturnForm() {

      const returnForm = document.querySelector('.js-return-form-container');
      const supportForm = document.querySelector('.js-support-form-container');
      const contactLinksGroups = document.querySelector('.js-contact-links-groups');

      if (!returnForm) return;

      const queryParams = new URLSearchParams(window.location.search);

      if (queryParams.get('return') === 'true') {
        returnForm.hidden = false;
        if (supportForm) supportForm.hidden = true;
        if (contactLinksGroups) contactLinksGroups.hidden = true;
      }
    }


    function initProductIdeasForm() {

      const productIdeasForm = document.querySelector('.js-product-ideas-form-container');
      const returnForm = document.querySelector('.js-return-form-container');
      const supportForm = document.querySelector('.js-support-form-container');
      const contactLinksGroups = document.querySelector('.js-contact-links-groups');

      if (!productIdeasForm) return;

      const queryParams = new URLSearchParams(window.location.search);

      if (queryParams.get('product-ideas') === 'true') {
        productIdeasForm.hidden = false;
        if (returnForm) returnForm.hidden = true;
        if (supportForm) supportForm.hidden = true;
        if (contactLinksGroups) contactLinksGroups.hidden = true;
      }
    }


    initContactForm();
    initReturnForm();
    initProductIdeasForm();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-how-everything-works"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initReviewsSlider = () => {
      if (typeof Swiper === 'undefined') {
        return;
      }

      new Swiper('.about-book__reviews-wrap', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        navigation: {
          prevEl: document.querySelector('.slider__arrow--left'),
          nextEl: document.querySelector('.slider__arrow--right'),
        },
        loop: true,
        centeredSlides: true,
        slidesPerView: 1.2,
        breakpoints: {
          0: {
            spaceBetween: 12
          },
          768: {
            spaceBetween: 20,
            slidesPerView: 3.2,
          },
          1280: {
            spaceBetween: 20,
            slidesPerView: 3.8,
          }
        }
      });
    };
    initReviewsSlider();
  })();

  } catch(e) { console.error(e); }
})();
})();
